import styled from 'styled-components';

const ChannelListBlockContainer = styled.div<React.CSSProperties>`
  width: 100%;
`;

export default ChannelListBlockContainer;
